import { addEventListeners } from '/src/scripts/utils/common';

class Share {
  fb = () => {
    this.popup(`https://www.facebook.com/sharer/sharer.php?u=${this.url()}`);
  };

  tw = () => {
    this.popup(`https://twitter.com/intent/tweet?url=${this.url()}`);
  };

  in = () => {
    this.popup(`https://www.linkedin.com/shareArticle?url=${this.url()}`);
  };

  url = () => {
    return encodeURIComponent(location.href);
  };

  link = (el) => {
    navigator.clipboard.writeText(location.href).then(() => {
      el.classList.add('socials__btn_done');

      setTimeout(() => {
        el.classList.remove('socials__btn_done');
      }, 1000);
    });
  };

  popup = (url) => {
    window.open(url, '_blank');
  };
}

const share = new Share();

addEventListeners('.socials__btn[data-action="tw"]', 'click', share.tw);
addEventListeners('.socials__btn[data-action="fb"]', 'click', share.fb);
addEventListeners('.socials__btn[data-action="in"]', 'click', share.in);
addEventListeners('.socials__btn[data-action="link"]', 'click', (e) => {
  share.link(e.currentTarget);
});
